<template>
  <b-modal v-model="showModal" centered hide-header hide-footer size="md">
    <div class="modal-header">
      <h3 class="font-weight-bold">
        {{ form.id ? "แก้ไข" : "เพิ่ม" }} Signature
      </h3>
      <button type="button" aria-label="Close" class="close" @click="hide">
        ×
      </button>
    </div>

    <div class="mt-3">
      <InputText
        textFloat="ชื่อ"
        placeholder="ระบุชื่อ"
        type="text"
        name="name"
        v-model="form.name"
        isRequired
      />
      <InputText
        textFloat="ตำแหน่ง"
        placeholder="ระบุชื่อตำแหน่ง"
        type="text"
        name="position"
        v-model="form.position"
        isRequired
      />
      <div class="d-flex justify-content-end align-items-center mt-4">
        <div class="d-sm-flex">
          <b-button class="button btn-cancel ml-2" @click="hide()"
            >ย้อนกลับ</b-button
          >
          <b-button
            :disabled="!form.name || !form.position"
            class="btn-main ml-3"
            @click="handleData"
            >บันทึก</b-button
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";

export default {
  name: "ModalSingature",
  components: {
    InputText,
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      form: {
        id: 0,
        name: "",
        position: "",
      },
    };
  },
  methods: {
    hide() {
      this.showModal = false;
    },
    show: async function (item = false) {
      if (item) {
        this.form = { ...item };
      }
      this.showModal = true;
    },
    handleData() {
      this.$emit("handleData", this.form);
      this.hide();
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-header {
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}
</style>
